import { types } from '../../types/types';
import { startSpinner, finishSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { changeStepper } from "../preAfiliado/stepper";
import MedicosAbmService from '../../services/MedicosAbmService';

export const abmMedicosTraerStart = () => ({ type: types.abmMedicosTraerStart });
export const abmMedicosTraerError = (error) => ({ type: types.abmMedicosTraerError, payload: error});
export const abmMedicosTraerSuccess = (payload) => {
  return {
    type: types.abmMedicosTraerSuccess,
    payload
  }
};

export const seleccionAbmMedicos = (medico) => ({
    type: types.abmMedicosSeleccionado,
    payload: medico
});

export const desSeleccionarAbmMedicos = () => ({
  type: types.abmMedicosLimpiarSeleccion,
});

export const desSeleccionarAbmMedicosConsulta = () => ({
  type:types.abmMedicosConsultaLimpiarSeleccion,
});
export const desSeleccionarAbmMedicosNuevo = () => async (dispatch) => {
  dispatch({
    type: types.abmMedicosNuevoLimpiarSeleccion,
  });
};
export const abmMedicosTraerPorCUITStart = () => ({
  type: types.abmMedicosTraerPorCUITStart,
});
export const medicosAbmTraerPorCUITError = (error) => ({
  type: types.abmMedicosTraerPorCUITError,
  payload: error,
});
export const abmMedicosTraerPorCUITSuccess = (payload) => {
  return {
    type: types.abmMedicosTraerPorCUITSuccess,
    payload,
  };
};
export const nuevosMedicosAbmDatos = (payload) => ({
  type: types.abmMedicosNuevoMedicoStep,
  payload
})
export const desSeleccionarMedicoAbmNuevo = () => async (dispatch) => {
  dispatch({
    type: types.abmMedicosNuevoLimpiarSeleccion,
  });
};

export const abmMedicosLimpiar = () => ({ type: types.limpiarMedicosAbm });

export const medicosAbmStoreOrUpdate = (medico, step) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      let response=null;
      if(medico.idEfectorRed){
        response = await MedicosAbmService.actualizarMedico(medico)
      }else{
        response = await MedicosAbmService.guardarMedico(medico)
      }
      const body = await response.json()
      if (response.ok) {
          dispatch(nuevosMedicosAbmDatos(medico.idEfectorRed ? medico : body))
          dispatch(changeStepper(step + 1))
          dispatch(finishSpinner());
      }else{
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner())
      if (error.errores && error.errores.mensaje) {
        dispatch(startAlerta(error.errores.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
    }
  };
};